import React from 'react';
import ReactDOM from 'react-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import smoothscroll from 'smoothscroll-polyfill';
import App from './App';
import './index.css';
import store, { persistor } from './redux/store';

// clear hubspot and fb cookies
document.cookie = 'hubspotutk=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
document.cookie = '_fbp=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';

smoothscroll.polyfill();
// TODO: have Helmet htmlAttribues lang be controlled by a state that is sync with our translator
document.addEventListener('DOMContentLoaded', (event) => {
  ReactDOM.render(
    <React.StrictMode>
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <BrowserRouter>
            <HelmetProvider>
              <Helmet htmlAttributes={{ lang: 'fi' }}>
                <meta charSet="utf-8" />
                <title>Oma Koti</title>
                <meta
                  name="viewport"
                  content="width=device-width, initial-scale=1"
                />
              </Helmet>
              <App />
            </HelmetProvider>
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </React.StrictMode>,
    document.getElementById('root'),
  );
});
